// src/middleware/auth.js
import axios from "axios";

export default function auth({next, router}) {
    console.log("middleware!!")
    var url = new URL(location.href)

    if (url.pathname.includes("index")) {
        var encryptedData = url.searchParams.get('data');
        let data = {
            EncryptedData: encryptedData
        };

         axios.post(`/api/auth/decrypt`, data)
            .then(response => {
                let resp = response.data;
                console.log("decrypted fisherData", resp);

                if (sessionStorage.getItem("personId") != null && sessionStorage.getItem("personId") == resp.personId) {
                    var token = decodeURIComponent(url.searchParams.get('data'))
                    // return router.push(`/meetings?data=${encodeURIComponent(token)}`);
                    return next();
                } else {
                    localStorage.clear();
                    sessionStorage.clear();
                    var token = decodeURIComponent(url.searchParams.get('data'))
                    return router.push(`/signin?data=${encodeURIComponent(token)}`);
                }

            })
            .catch(error => {
                console.log(error)
                var token = decodeURIComponent(url.searchParams.get('data'))
                return router.push(`/signin?data=${encodeURIComponent(token)}`);
            })
    } else {
        if (!sessionStorage.getItem('authToken')) {
            var token = decodeURIComponent(url.searchParams.get('data'))
            return router.push(`/signin?data=${encodeURIComponent(token)}`);
        }
    return next();
    }
}
